import PropTypes from 'prop-types';
// material
import { Grid } from '@mui/material';
import ImagemCard from './ImagemCard';

// ----------------------------------------------------------------------

ProductList.propTypes = {
  products: PropTypes.array.isRequired
};

export default function ProductList({ products, ...other }) {
  return (
    <Grid container spacing={3} {...other}>
      {products.sort((a,b) => a.id - b.id).map((product) => (
        <Grid key={product.id} item xs={12} sm={6} md={3}>
          <ImagemCard product={product} />
        </Grid> 
      ))}
    </Grid>
  );
}   
